import React, {FC, useEffect, useState} from "react"
import {H2, Label} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import {FormattedMessage} from "@irati/utils/lang"
import {useSavingsCalculatorDealBrandList, useWeeklyBudget} from "@irati/deal-brands/hooks"
import Flex from "@irati/ui/src/Flex"
import {Radio} from "@irati/ui/src/FormItem"
import withAuth, {WithAuth} from "@irati/auth/helpers/auth/withAuth"
import {Container, Img, LeftColumn, RightColumn} from "./styles"
import RightColumnContent from "./RightColumnContent"

const brandKey = "brand"
const budgetKey = "budgetOptions"

interface Props extends WithAuth {}

const MySavingsCalculator: FC<Props> = ({auth}) => {
  const {productPermissions} = auth
  if (!productPermissions.perks) return null

  const theme = useTheme()
  const brandList = useSavingsCalculatorDealBrandList({}) ?? []
  const weeklyBudget = useWeeklyBudget({})

  const [selectedUuid, setSelectedUuid] = useState(localStorage.getItem(brandKey) ?? undefined)
  const [selectedOption, setSelectedOption] = useState(localStorage.getItem(budgetKey) ?? undefined)

  useEffect(() => {
    if (weeklyBudget.data && !selectedOption) {
      setSelectedOption(weeklyBudget?.data?.budget?.[1]?.value)
    }
  }, [selectedOption, weeklyBudget])

  if (!brandList.data) return null
  if (!weeklyBudget.data) return null

  const selectBrand = (brand) => {
    localStorage.setItem(brandKey, brand.uuid)
    setSelectedUuid(brand.uuid)
  }

  const handleSelectOption = (option: string) => {
    localStorage.setItem(budgetKey, option)
    setSelectedOption(option)
  }

  return (
    <Container>
      <LeftColumn>
        <H2 color={theme.colors.greys.white}>
          <FormattedMessage id="platform.mySavingsCalculator.header" />
        </H2>
        <Flex direction="column" gap={theme.spacing.one}>
          <Label color={theme.colors.greys.white}>
            <FormattedMessage id="platform.mySavingsCalculator.brandsLane.title" />
          </Label>
          <Flex gap={theme.spacing.one} wrap="wrap">
            {brandList?.data?.map((brand) => {
              return (
                <Flex>
                  <a onClick={() => selectBrand(brand)}>
                    <Img src={brand.img} selectedBrand={selectedUuid === brand.uuid} initialOpacityState={!selectedUuid} />
                  </a>
                </Flex>
              )
            })}
          </Flex>
        </Flex>

        <Flex direction="column" gap={theme.spacing.one}>
          <Label color={theme.colors.greys.white}>
            <FormattedMessage id="platform.mySavingsCalculator.budgetLane.title" />
          </Label>
          <Radio
            name="weeklyBudget"
            value={selectedOption}
            onChange={handleSelectOption}
            options={weeklyBudget?.data?.budget}
            inline
            justifyRadios="flex-start"
          />
        </Flex>
      </LeftColumn>
      <RightColumn>
        <RightColumnContent
          brandList={brandList.data}
          currency={weeklyBudget.data?.currency!}
          selectedUuid={selectedUuid}
          selectedAmount={selectedOption!}
        />
      </RightColumn>
    </Container>
  )
}

export default withAuth(MySavingsCalculator)
